// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifos.mobile.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Int
import kotlin.Long
import kotlin.OptIn
import kotlin.Suppress
import kotlinx.coroutines.flow.Flow
import org.mifos.mobile.core.model.entity.Page
import org.mifos.mobile.core.model.entity.Transaction

@OptIn(InternalKtorfitApi::class)
public class _RecentTransactionsServiceImpl(
  private val _ktorfit: Ktorfit,
) : RecentTransactionsService {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override fun getRecentTransactionsList(
    clientId: Long,
    offset: Int?,
    limit: Int?,
  ): Flow<Page<Transaction>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "clients/${"$clientId".encodeURLPath()}/transactions")
        offset?.let{ parameter("offset", "$it") }
        limit?.let{ parameter("limit", "$it") }
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<Page<Transaction>>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }
}

public class _RecentTransactionsServiceProvider : ClassProvider<RecentTransactionsService> {
  override fun create(_ktorfit: Ktorfit): RecentTransactionsService = _RecentTransactionsServiceImpl(_ktorfit)
}

public fun Ktorfit.createRecentTransactionsService(): RecentTransactionsService = _RecentTransactionsServiceImpl(this)
